import { render, staticRenderFns } from "./EventArchiveModal.vue?vue&type=template&id=45a91dd0"
import script from "./EventArchiveModal.vue?vue&type=script&lang=js"
export * from "./EventArchiveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports